// DEC-2026-0927-03: when a house publishes only a flat notes list (Dua's
// "NOTES:" line), the catalog stores it in all_notes and leaves the tiers
// empty. Screens show it as "Notes", never as a pyramid.
//
// all_notes is a text column ("Bergamot, Lemon, Musk"). ExplorePage checked
// Array.isArray(all_notes), which is never true for text, so its untiered line
// never rendered; both screens read it through this helper instead.
export function hasNoteTiers(row) {
  return ['top_notes', 'mid_notes', 'base_notes'].some(key => Array.isArray(row?.[key]) && row[key].length > 0)
}

export function untieredNotes(row) {
  if (!row || hasNoteTiers(row)) return []
  const raw = row.all_notes
  const list = Array.isArray(raw) ? raw : String(raw || '').split(',')
  const seen = new Set()
  return list
    .map(note => String(note || '').trim())
    .filter(note => {
      const key = note.toLowerCase()
      if (!note || seen.has(key)) return false
      seen.add(key)
      return true
    })
}
